import React from 'react';

export const Terms = () => {
  return (
    <div className="container-terms">
      <p>
        <h1 className="header-black">
          Terms and Conditions
          <br/>
        </h1>
        If you establish an account with us, your payment through our payment
        gateway service binds you to our payment terms, which may include
        recurring payments, fees and premiums that will draft from your account
        or bill your credit card, debit card or checking account. The first
        payment made by you constitutes the agreement to the payment terms on
        your account and authorizes us to bill you according to those terms. As
        the user of our billing service, you will have submitted your banking
        account or credit card or debit card account information. <br/>
        You are responsible for any legal, regulatory, or banking penalties and
        fees that may be assessed for supplying false information. You agree
        that you are the authorized signer for the account. By providing us with
        the account information, you authorize us to process payments on your
        account for products or services provided to you. We will process any
        payment as close as reasonably possible to the date indicated in your
        payment schedule, provided to you at time of purchase. <br/>
        If your payment is received by us after the due date, with no
        exceptions, including the payment service being temporarily unavailable,
        you agree that you may be subject to additional fees and charges and you
        may have your policy or service canceled. Any payment or installment
        attempt on your account that is returned from the bank for any reason,
        may be charged additional returned item fee(s), which will be added to
        the original amount and auto-debited from your account. Your bank or
        card holder may also charge you additional fees. If you cancel your
        policy, your payments are subject to a refund. <br/>
        If prior to the policy effective date, you are subject to a full refund,
        less earned policy fee in some states. If your cancellation effective
        date is after your policy effective date, any refund is prorated based
        on the days coverage was provided and fees earned. Billing installment
        fees are non-refundable. We reserve the right to cancel your policy for
        non-payment and may reserve the right to not accept payment to reinstate
        for repeated non-payments or returned payments. You will be liable for
        any return check fees and late payment penalties. <br/>
        Acceptance of a payment does not ensure that policies cancelled for
        non-payment will be reinstated. You authorize us to initiate
        transactions, including all fees, to your transaction account number
        (including checking and savings accounts) and/or charges to your credit
        or debit card. We make every effort to comply with all payment
        processing rules and regulations. <br/>
        If you believe you have been charged a fee or payment in error, please
        contact your agent or visit our contact us page for information on
        inquiries. We reserve the right to refuse processing service to you at
        any time for any reason. You may also discontinue use of the Payment
        Gateway at any time for any reason. <br/>
        <strong>IT IS YOUR RESPONSIBILITY</strong> to delete your account for
        recurring payments to be discontinued, otherwise charges will continue
        to be assessed to your billing account during the period designated for
        recurring payments to take place. You agree to indemnify and hold us
        harmless for any recurring payments that are charged by accident or
        because you failed to cancel your recurring payment. You can cancel your
        service by calling your agent or us. Contact your agent with any
        questions you may have regarding your account.
      </p>
    </div>
  );
};
export default Terms;
